import { CHART_TO_COMPONENT } from '@/chart/components/all-charts';
import { ChartSizer } from '@/chart/components/all-charts-styles';
import Header from '@/chart/components/header';
import { BETA_FEATURES } from '@/constants';
import { isBetaFeatureEnabled } from '@/data/data-selectors';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { DetailsVisHeader } from './details-vis-header';

const MINIMUM_DATA_POINTS_FOR_RENDER = 3;
const CHART_GROUPS = [
  {
    ariaLabel: 'revenue',
    chart: CHART_TO_COMPONENT.REVENUE,
    key: 'REVENUE',
  },
  {
    ariaLabel: 'occupancy',
    chart: CHART_TO_COMPONENT.OCCUPANCY,
    key: 'OCCUPANCY',
  },
  {
    ariaLabel: 'average daily rate',
    chart: CHART_TO_COMPONENT.AVG_DAILY_RATE,
    key: 'AVG_DAILY_RATE',
  },
  {
    ariaLabel: 'transient occupancy tax',
    chart: CHART_TO_COMPONENT.TRANSIENT_OCCUPANCY_TAX,
    key: 'TRANSIENT_OCCUPANCY_TAX',
  },
];

const ChartContainer = styled.button`
  width: 300px;
  height: 300px;
  border-radius: 10px;
  border: solid 1px #e6e6e9;
  background-color: rgba(255, 255, 255, 0.85);
  box-shadow:
    0 0.4px 0.6px 0 rgba(8, 10, 37, 0.03),
    0 0.8px 1.7px 0 rgba(8, 10, 37, 0.05),
    0 3px 4.5px 0 rgba(89, 126, 247, 0.03),
    0 1.5px 7px 0 rgba(89, 126, 247, 0.03);
  padding: 30px 23px 15px 30px;
  display: flex;
  flex-direction: column;
  flex: 1 1 100%;
`;

export const PropertyDetailsCharts = (props) => {
  const { propertyData, setCurrActiveModal } = props;

  const enableActualTOT = useSelector(
    isBetaFeatureEnabled(BETA_FEATURES.aggregateStatisticsTOTGraphActual)
  );

  const chartBuilderOptions = useMemo(
    () => ({ enableActualTOT }),
    [enableActualTOT]
  );

  if (propertyData.dataPoints.length < MINIMUM_DATA_POINTS_FOR_RENDER) {
    return null;
  }

  return (
    <div>
      <DetailsVisHeader title="Aggregate Statistics" />

      <div
        aria-label="Group of performance charts"
        className="grid grid-cols-2 gap-6"
      >
        {CHART_GROUPS.map(({ ariaLabel, chart: Chart, key }) => (
          <ChartContainer
            key={key}
            aria-label={`Open ${ariaLabel} chart`}
            onClick={() => setCurrActiveModal(key)}
          >
            <Header
              chartName={key}
              propertyData={propertyData}
              additionalHeaderOptions={chartBuilderOptions}
              abbreviateIndicators
            />
            <ChartSizer>
              <Chart
                chartName={key}
                propertyData={propertyData}
                spaceBetweenGridAndXAxis={5}
                setCurrActiveModal={setCurrActiveModal}
                builderOptions={chartBuilderOptions}
              />
            </ChartSizer>
          </ChartContainer>
        ))}
      </div>
    </div>
  );
};
